import { isValidSchema } from "./util";
import { Mosaic } from "./capturesystemmosaic";
// FIXME: "by2" should it not just be "by"
export class CaptureSystemSensor {
    constructor(mosaic, focallength, by2, domega, dphi, dkappa, bx, bz, pos) {
        this.mosaic = mosaic;
        this.focallength = focallength;
        this.by2 = by2;
        this.domega = domega;
        this.dphi = dphi;
        this.dkappa = dkappa;
        this.bx = bx;
        this.bz = bz;
        this.pos = pos;
    }
    static create(payload) {
        return new CaptureSystemSensor(Mosaic.create(payload.mosaic), payload.focallength, payload.by2, payload.domega, payload.dphi, payload.dkappa, payload.bx, payload.bz, payload.pos);
    }
    static isValid(payload) {
        const schema = ["mosaic", "focallength", "by2", "domega", "dphi", "dkappa", "bx", "bz", "pos"];
        return isValidSchema(payload, schema) && Mosaic.isValid(payload.mosaic);
    }
}
//# sourceMappingURL=capturesystemsensor.js.map